export default __webpack_public_path__ + "static/media/a017-line9.6a637c4a.svg";